import React from "react";
import PropTypes from "prop-types";
import { captureException } from "../monitoring";

// Captura erros de render de componentes e reporta ao Sentry/GlitchTip.
// Não renderiza fallback UI — preserva o comportamento default do React
// (árvore desmontada) para não introduzir mudanças visuais.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.hasError) return null;

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
